import { AppCheck } from 'firebase/app-check'
import { createState } from 'shared'

import { AuthState } from './types'

export const authStatus = createState<AuthState>(AuthState.loading)
export const authState = authStatus.state

const firebaseAppCheck = createState<AppCheck | null>(null)
export const firebaseAppCheckState = firebaseAppCheck.state

export const updateAuthState = authStatus.updateState
export const updateFirebaseAppCheckState = firebaseAppCheck.updateState
